import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  Newsfeed,
  LoadNewsfeedRequest,
  LoadNewsfeedResponse,
  UpdateNewsFeedStatusRequest
} from '@features/admin/models/newsfeed.model';
import { delay, Observable, of } from 'rxjs';
import { IResponse } from '@shared/models/base/http-response.model';
import { MOCK_NEWSFEED } from '@features/admin/models/newsfeed.mock';
import { environment } from '@env/environment';
import { stripTime } from '@shared/utils/date.utils';

@Injectable({
  providedIn: 'root'
})
export class NewsFeedService {

  private readonly http: HttpClient = inject(HttpClient);

  public loadNewsFeeds(request: LoadNewsfeedRequest): Observable<IResponse<LoadNewsfeedResponse>> {
    return this.http.post<IResponse<LoadNewsfeedResponse>>(
      new URL('NewsFeed/GetNewsFeed', environment.apiUrl).href, request
    );
  }

  public addNewsfeed(newsfeed: Newsfeed): Observable<IResponse<Newsfeed>> {
    return this.http.post<IResponse<Newsfeed>>(
      new URL('NewsFeed/SaveNewsFeed', environment.apiUrl).href,
      newsfeed,
    );
  }

  public updateNewsfeed(newsfeed: UpdateNewsFeedStatusRequest): Observable<IResponse<boolean>> {
    return this.http.post<IResponse<boolean>>(
      new URL('/NewsFeed/UpdateActiveStatus', environment.apiUrl).href,
      newsfeed,
    );
  }

  public deleteNewsfeed(newsfeedId: string): Observable<IResponse<boolean>> {
    return this.http.delete<IResponse<boolean>>(
      new URL(`/NewsFeed/${newsfeedId}`, environment.apiUrl).href
    );
  }

  public getActiveBannerNews(bannerNews: Newsfeed[]): Newsfeed[] {
    const today = stripTime(new Date());

    return bannerNews.filter((newsFeed) => {
      const startDate = stripTime(new Date(newsFeed.startDate));
      const endDate = stripTime(new Date(newsFeed.endDate));
      return (startDate <= today && endDate >= today) && newsFeed.isActive;
    });
  }
}
